export default __webpack_public_path__ + "static/media/slider-img-5.a8115a58.png";